<template>
  <div
    v-if="modalIsOpened"
    class="fixed inset-0 w-full bg-black/30 z-51"
    @click.self="closeModal"
  >
    <div
      class="fixed inset-0 overflow-y-auto flex items-start justify-center py-8"
    >
      <div class="w-[100vw] max-w-[350px] px-[20px] overflow-hidden m-auto">
        <!-- actual modal -->
        <div class="mx-auto box-effect rounded-[10px] bg-white overflow-hidden">
          <div
            id="title"
            class="flex items-center justify-between py-[12px] pl-[20px] pr-[10px] bg-[#9B237B]"
          >
            <span class="PC_Body2-R text-[#FCFCFC]">
              {{ !checkEdit ? "เพิ่มประเภท" : "แก้ไขประเภท" }}
            </span>
            <CloseIcon
              @click="closeModal"
              class="w-[24px] h-[24px] bg-white text-[#9B237B] rounded-full cursor-pointer"
            />
          </div>

          <div class="flex flex-col p-[20px] gap-[16px] bg-[#FCFCFC]">
            <Input
              label="ชื่อประเภท"
              placeholder="ชื่อประเภท"
              v-model="form.name"
              :warningMessage="errors.name"
            />
            <div class="w-full flex justify-center items-center gap-[10px]">
              <ButtonComponent
                :label="'บันทึก'"
                :bClass="'btn_shadow--onlySave'"
                :disabled="form.name == ''"
                @clicked="save"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
import { useGlobals } from "@/components/Utilities/javascripts/useGlobals";
import { useProductStore } from "@/pinia/product";

const { $validateMsg } = useGlobals();
const productStore = useProductStore();

const input = {
  id: "",
  name: "",
};
const form = ref({ ...input });
const errors = ref({ ...input });
const checkEdit = ref(false);
const modalIsOpened = ref(false);

const emit = defineEmits(["status", "update"]);

const openModal = (item) => {
  modalIsOpened.value = true;
  document.body.style.overflow = "hidden";

  checkEdit.value = !!item;
  form.value = {
    ...input,
  };
  errors.value = {
    ...input,
  };
  if (item) {
    form.value.id = item.id;
    form.value.name = item.name;
  }
};

const closeModal = () => {
  modalIsOpened.value = false;
  document.body.style.overflow = "auto";
};

const save = () => {
  if (checkEdit.value) {
    update();
  } else {
    add();
  }
};

const update = async () => {
  await productStore
    .updateProductType(form.value)
    .then((response) => {
      if (response.status === 200) {
        emit("status", response.data.message, "success");
        emit("update");
        closeModal();
      }
    })
    .catch((error) => {
      console.log("error", error);
      if (error.status === 400) {
        emit("status", error.response.data.message, "error");
        closeModal();
      } else {
        $validateMsg(error.response.data.errors, errors.value);
      }
    });
};

const add = async () => {
  await productStore
    .createProductType(form.value)
    .then((response) => {
      if (response.status === 201) {
        emit("status", response.data.message, "success");
        emit("update");
        closeModal();
      }
    })
    .catch((error) => {
      console.log("error", error);
      if (error.status === 400) {
        emit("status", error.response.data.message, "error");
        closeModal();
      } else {
        $validateMsg(error.response.data.errors, errors.value);
      }
    });
};

defineExpose({ openModal });
</script>
    
<style lang="scss" scoped>
</style>